import { css } from "@emotion/react";
import styled from "@emotion/styled";

type SwatchButtonProps = {
	active: boolean;
};

const swatchSize = 30;
export const SwatchImage = styled.img``;
export const SwatchButton = styled.button<SwatchButtonProps>`
	${({ active }) => {
		const boxShadowActive = css`
			box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.65);
		`;
		const boxShadowHover = css`
			box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35);
		`;
		return css`
			appearance: none;
			background: transparent;
			margin: 0;
			cursor: pointer;
			border-radius: 999px;
			width: ${swatchSize + 4}px;
			height: ${swatchSize + 4}px;
			display: inline-flex;
			align-items: center;
			justify-content: center;

			${active && boxShadowActive}

			${SwatchImage} {
				width: ${swatchSize}px;
				height: ${swatchSize}px;
				border-radius: 999px;
				display: block;
				${!active && boxShadowHover}
			}

			&:hover {
				${!active && boxShadowHover}
				${SwatchImage} {
					box-shadow: none;
				}
			}
		`;
	}}
`;

export const EditableProducts = styled.div``;
export const ProductLabel = styled.p``;
export const ColorSelect = styled.div``;

type AccordionProps = {
	open: boolean;
};
export const Accordion = styled.div<AccordionProps>`
	${({ open }) => {
		return css`
			${AccordionHeader} {
				position: relative;
				z-index: 2;
				display: flex;
				justify-content: space-between;
				align-items: center;
				:hover {
					cursor: pointer;
					${AccordionHeaderButton} {
						scale: 1.2;
					}
				}

				${AccordionHeaderButton} {
					padding: 2px;
					margin-right: 2px;
				}
			}

			${AccordionContent} {
				position: relative;
				z-index: 1;
				overflow: hidden;
				display: grid;
				grid-template-rows: ${open ? 1 : 0}fr;
				transition: grid-template-rows 250ms ease;

				${ColorSelect} {
					overflow: hidden;
					user-select: none;
					display: flex;
					flex-wrap: wrap;
					align-items: center;
					gap: 4px;
					padding: 2px;
					margin-top: 0;
					opacity: 0;
					transform: translateY(-100%);
					transition:
						opacity 250ms ease,
						margin-top 250ms ease,
						transform 250ms ease;
					${open &&
					css`
						opacity: 1;
						margin-top: 18px;
						transform: translateY(0);
					`};
				}
			}
		`;
	}}
`;
export const AccordionHeader = styled.div``;
export const AccordionHeaderButton = styled.div``;
export const AccordionContent = styled.div``;
export const CloseButtonContainer = styled.div``;
export const MultiEditPenPanel = styled.div`
	${() => {
		return css`
			height: 100%;
			width: 100%;
			display: flex;
			flex-direction: column;
			gap: 15px;
			overflow: hidden;

			${EditableProducts} {
				display: flex;
				flex-direction: column;
				gap: 20px;
				overflow-y: auto;
				min-height: 0;
				padding: 0 12px;

				${ProductLabel} {
					font-size: 16px;
					margin: 0;
					line-height: 100%;
					font-weight: 300;
				}
			}

			${CloseButtonContainer} {
				flex-shrink: 0;
				padding: 0 12px;
			}
		`;
	}}
`;
